<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w0u5cp/tc-custom/FC-9781528968980.jpg?1684871068687?1709061750253" alt="This image is the cover for the book Destiny on Magic White Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Destiny on Magic White Mountain
      </h1>
      <p class="bookDescription body article font2">
        <p>It is Spring 1988. The Chinese government is hungry for mineral resources in order to provide infrastructure to an awakening industrial global giant and for gold that will help fund it. Professor Qiu sets his postgraduates, Liang and Xinhua, the task of developing a small exploration team to discover new gold deposits in the mountainous Jilin Province, near the Korean border. Their literature research leads them to a promising gold district with an ancient ‘Head of the Dragon’ gold mine. On arrival at the local village, they find that the mine-tunnel entrance on the hillside was sealed by an earthquake-induced landslide 500 years earlier and also buried half the village with many casualties. The superstitious villagers have never uncovered the landslide and reopened the mine because they hear strange sounds emanating from the hillside, which is why they have renamed it the Magic White Mountain. By studying the location’s geology, Liang and Xinhua believe they could discover the Tail of the Dragon gold mine, but first they must explore and map the old one. They open the tunnel and enter the mine, never in their wildest dreams imagining what they will encounter and how their experiences will forever change their lives and fulfil their pre-ordained destinies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Ian Groves
      </h2>
      
      <p class="authorDescription body article">David was born in Brighton, UK, but mainly educated in Australia. He is Emeritus Professor of Economic Geology at the University of Western Australia, a Fellow of the Australian Academy of Science and a National Geoscience Champion, having received numerous medals and other awards for his teaching and research. He is also a consultant to the mining and exploration industry, mainly involved in conceptual targeting for discovery of new mineral deposits. He has adapted his holistic and multi-scale approach to forensic geological studies into the writing of cerebral thriller, mystery and mystical novels, involving a gold exploration background, with The Plagues’ Protocol the first of this genre and Destiny on Magic White Mountain the second.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8010cfc